import React, { useEffect } from 'react';
import moment from 'moment';
import Logo from '../../../images/logo.png';

const PrintApplyPayment = ({
  isShow, paymentData, rentalData, printWindow
}) => {
  const {
    paymentMethod,
    paymentBankName,
    paymentAccountNumber,
    paymentAccountHolderName,
    paymentReceiptAmount,
    paymentMethodOther,
    paymentTotalAmount,
    paymentRemarks
  } = paymentData || {};
  console.log('PrintApplyPayment Props:', { isShow, paymentData, rentalData, printWindow });
  const prepaymentAmount = Number((rentalData && rentalData.prepaymentAmount) || 0);
  const rentalAmount = Number((rentalData && rentalData.rentalAmount) || 0);
  const serviceFee = Number((rentalData && rentalData.serviceFee) || 0);
  const mealFee = Number((rentalData && rentalData.mealFee) || 0);

  useEffect(() => {
    const targetWindow = printWindow || window;
    
    setTimeout(() => {
      targetWindow.print();
      
      const afterPrintHandler = () => {
        targetWindow.close();
      };
      
      targetWindow.addEventListener('afterprint', afterPrintHandler);

      return () => {
        targetWindow.removeEventListener('afterprint', afterPrintHandler);
      };
      
    }, 500);

  }, [printWindow]);

  if (!rentalData) return null;

  const finalPaymentMethod = paymentMethod === '其他' ? paymentMethodOther : paymentMethod;

  return (
    <div className="print-document-container" style={{
      margin: '0 auto',
      fontSize: '14px',
      minWidth: '700px',
      maxWidth: '700px',
      padding: '0',
      height: '250mm',
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box',
    }}>
      
      {/* 申請請款單聯 */}
      <div style={{ position: 'relative', overflow: 'hidden' }}>
        <div className="u-small-title" style={{margin:'auto', width:'200px',backgroundColor:'#291e1b', padding: '16px'}}>
            <img src={Logo} width="120px" alt='' />
        </div>
        <div style={{textAlign:'center', height:'70px', top:'20px',fontSize:'24px', fontWeight:'bold'}}>請款單</div>

        <form className="u-form" style={{ margin: '0 0 0 auto', width: '95%', paddingBottom:'20px' }}>

          {/* 申請日期 */}
          <div style={{ display: 'flex', border: '1px solid black' }}>
            <div style={{ width: '150px', padding: '8px', borderRight: '1px solid black', fontWeight: 'bold' , textAlign: 'center' }}>申請日期</div>
            <div style={{ flex: 1, padding: '8px' }}>
              {moment().format('YYYY-MM-DD')}
            </div>
          </div>

          {/* 付款對象 */}
          <div style={{ display: 'flex', border: '1px solid black' }}>
            <div style={{ width: '150px', padding: '8px', borderRight: '1px solid black', fontWeight: 'bold', textAlign: 'center'  }}>付款對象</div>
            <div style={{ flex: 1, padding: '8px' }}>
              {rentalData.tenantName || ''}
            </div>
          </div>

          {/* 付款明細 */}
          <div style={{ display: 'flex', border: '1px solid black', alignItems: 'center' }}>
            <div style={{ width: '150px', padding: '8px', borderRight: '1px solid black', fontWeight: 'bold', textAlign: 'center'  }}>付款明細</div>
            <div style={{ flex: 1, padding: '8px' }}>
              <div style={{ marginBottom: '8px' }}>
                <div style={{ marginBottom: '4px' }}>預收金額: <strong>{prepaymentAmount}</strong></div>

              </div>
            </div>
          </div>

          {/* 金額 */}
          <div style={{ display: 'flex', border: '1px solid black' }}>
            <div style={{ width: '150px', padding: '8px', borderRight: '1px solid black', fontWeight: 'bold' , textAlign: 'center' }}>金額</div>
            <div style={{ flex: 1, padding: '8px'}}>
              總金額$ {(rentalData && rentalData.paymentTotalAmount) || 0} 元
            </div>
          </div>

          {/* 付款資訊區塊 */}
          <div style={{ display: 'flex', border: '1px solid black' }}>
            <div style={{ 
              width: '150px', 
              padding: '8px', 
              borderRight: '1px solid black', 
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              付款方式
            </div>

            <div style={{ flex: 1 }}>
              {/* 付款方式 */}
              <div style={{ padding: '8px', borderBottom: '1px solid black' }}>
                <div style={{fontWeight: 'bold'}}>{rentalData.paymentMethod}</div>
              </div>

              {/* 銀行名稱 */}
              <div style={{ padding: '8px', borderBottom: '1px solid black' }}>
                <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '4px' }}>銀行名稱</label>
                <div>{rentalData.paymentBankName || ''}</div>
              </div>

              {/* 帳號 */}
              <div style={{ padding: '8px', borderBottom: '1px solid black' }}>
                <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '4px' }}>帳號</label>
                <div>{rentalData.paymentAccountNumber || ''}</div>
              </div>

              {/* 帳戶名 */}
              <div style={{ padding: '8px', borderBottom: '1px solid black' }}>
                <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '4px' }}>帳戶名</label>
                <div>{rentalData.paymentAccountHolderName || ''}</div>
              </div>

              {/* 收據金額 */}
              <div style={{ padding: '8px' }}>
                <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '4px' }}>金額</label>
                <div>{rentalData.paymentReceiptAmount || ''}</div>
              </div>
            </div>


          </div>
                                  {/* 備註事項 */}
          <div style={{ display: 'flex', border: '1px solid black' }}>
            <div style={{ width: '150px', padding: '8px', borderRight: '1px solid black', fontWeight: 'bold', textAlign: 'center' }}>備註事項</div>
            <div style={{ flex: 1, padding: '8px' }}>
              {rentalData.paymentRemarks || ''}
            </div>
          </div>
                  {/* 其他 */}
          <div style={{ display: 'flex', border: '1px solid black' }}>
            <div style={{ flex: 2, padding: '8px' , borderRight: '1px solid black', textAlign: 'center'}}>
                董事長&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;財務部
            </div>
            <div style={{ flex: 1, padding: '8px', textAlign: 'center' }}>
                經手人
            </div>
          </div>
                    <div style={{ display: 'flex', border: '1px solid black', height: '70px' }}>
            <div style={{ flex: 2, padding: '8px' , borderRight: '1px solid black'}}>
                
            </div>
            <div style={{ flex: 1, padding: '8px' }}>
                
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PrintApplyPayment;
